<template>
  <session-button
    :icon-name="isSharingScreen ? 'screenShareOffM' : 'screenShareM'"
    :is-active="isSharingScreen!"
    :disabled="disabled"
    data-test="screen-sharing-button"
    :title="screenShareTitle"
    @click="onToggle"
  />
</template>
<script lang="ts" setup>
import { computed, toRefs } from 'vue'

import { SessionButton } from '@/shared/components/buttons'
import { useLocalization } from '@/shared/composables/localization'

import { useToggleScreenSharing } from '../lib'

const props = withDefaults(defineProps<{
  sessionId: string
  disabled?: boolean
}>(), {
  disabled: false,
})

const { disabled } = toRefs(props)
const { t } = useLocalization()
const { isSharingScreen, toggle } = useToggleScreenSharing()

const screenShareTitle = computed(() => {
  if (disabled.value) {
    return t('common.isOnHold')
  }

  return isSharingScreen.value
    ? `${t('calls.endScreenSharing')} (${t('keys.S')})`
    : `${t('calls.startScreenSharing')} (${t('keys.S')})`
})

const onToggle = () => {
  if (disabled.value) {
    return
  }

  void toggle()
}
</script>
